import { AlertTriangle } from 'lucide-react';
import { isApiError } from '../../api/client';
import { cx } from '../../lib/cx';

/**
 * Every surfaced error shows its `requestId` so an admin can quote it when
 * reporting the problem (functional spec, API Contract Reference — error envelope).
 */
export function ErrorNotice({
  error,
  fallback = 'Something went wrong. Please try again.',
  className,
}: {
  error: unknown;
  fallback?: string;
  className?: string;
}) {
  if (!error) return null;
  const message = isApiError(error) ? error.message : fallback;
  const requestId = isApiError(error) ? error.requestId : null;
  const code = isApiError(error) ? error.code : null;

  return (
    <div
      role="alert"
      className={cx(
        'flex items-start gap-2 rounded border border-danger bg-danger-soft px-3 py-2 text-[13px] text-ink',
        className,
      )}
    >
      <AlertTriangle size={15} className="mt-0.5 shrink-0 text-danger" aria-hidden="true" />
      <div className="min-w-0">
        <p>{message}</p>
        <p className="mt-0.5 text-2xs text-ink-muted">
          {code ? <span className="tabular">{code}</span> : null}
          {code && requestId ? ' · ' : null}
          {requestId ? (
            <>
              request id <span className="tabular">{requestId}</span>
            </>
          ) : null}
        </p>
      </div>
    </div>
  );
}
